import axios from 'axios';

const state = {
  pendingEvents: [],
  pendingCities: [],
  membershipRequestList: [],
  unverifiedUserList: [],
  pendingLocations: [],
  dmoPartnerRequests: [],
};

const getters = {};

const actions = {
  async getPendingCities({ commit }) {
    const response = await axios.get(`${process.env.VUE_APP_API_ROOT}/admin/getPendingCities`);
    commit('setPendingCities', response.data.change_requests);
  },
  async getDMOPartnerRequests({ commit }) {
    const response = await axios.get(`${process.env.VUE_APP_API_ROOT}/roles/requests?role=dmo&status=Requested`);
    commit('setDMOPartnerRequests', response.data.requests);
  },
  async getPendingEvents({ commit }) {
    const response = await axios.get(`${process.env.VUE_APP_API_ROOT}/admin/getPendingEvents`);
    commit('setPendingEvents', response.data.change_requests);
  },
  async getMembershipRequests({ commit }) {
    const response = await axios.get(`${process.env.VUE_APP_API_ROOT}/admin/getMembershipRequests`);
    commit('setMembershipRequests', response.data.membership_requests);
  },
  async getUnverifiedUsers({ commit }) {
    // eslint-disable-next-line no-useless-escape
    const response = await axios.post(`${process.env.VUE_APP_API_USERS_ROOT}/users/listUsers`, {
      filter: 'cognito:user_status = "UNCONFIRMED"',
    });
    commit(
      'setUnverifiedUsers',
      response.data.Users.map((u) => {
        const givenName = u.Attributes.find((a) => a.Name === 'given_name').Value;
        const familyName = u.Attributes.find((a) => a.Name === 'family_name').Value;
        const email = u.Attributes.find((a) => a.Name === 'email').Value;

        return {
          username: u.Username,
          first_name: givenName,
          last_name: familyName,
          email,
          confirmation_sent_at: u.UserCreateDate,
        };
      }),
    );
  },
  async getPendingLocations({ commit }) {
    const response = await axios.get(`${process.env.VUE_APP_API_ROOT}/admin/getPendingLocations`);
    commit('setPendingLocations', response.data.change_requests);
  },
};

const mutations = {
  setPendingEvents(st, changeRequests) {
    st.pendingEvents = changeRequests;
  },
  setPendingCities(st, changeRequests) {
    st.pendingCities = changeRequests;
  },
  setMembershipRequests(st, membershipRequests) {
    st.membershipRequestList = membershipRequests;
  },
  setUnverifiedUsers(st, unverifiedUsers) {
    st.unverifiedUserList = unverifiedUsers;
  },
  setPendingLocations(st, changeRequests) {
    st.pendingLocations = changeRequests;
  },
  setDMOPartnerRequests(st, requests) {
    st.dmoPartnerRequests = requests;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
